var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCautionIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 17.581c4.69 0 8.575-3.876 8.575-8.574 0-4.69-3.885-8.575-8.583-8.575C4.802.432.925 4.317.925 9.007c0 4.698 3.885 8.574 8.575 8.574Zm0-7.138c-.481 0-.755-.274-.772-.764l-.124-4.183c-.017-.507.356-.864.888-.864.53 0 .913.366.896.872l-.124 4.175c-.017.498-.29.764-.764.764Zm0 2.855c-.548 0-1.013-.398-1.013-.946 0-.54.457-.946 1.013-.946.565 0 1.013.406 1.013.946 0 .556-.457.946-1.013.946Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCautionIcon);
export default __webpack_public_path__ + "static/media/cautionIcon.bba5efb3d1ec56b6989090ed36e44266.svg";
export { ForwardRef as ReactComponent };